import { useState } from 'react'
import { RecognitionResultProduct } from 'api/fragments/types'
import {
  CapturedWineDocument,
  useProductRecognitionResultSaveMutation,
} from 'api/hooks'
import { getLocaleId } from 'utils/getLocaleId'
import useNotification from 'utils/notification'
import { useTranslation } from 'react-i18next'
import useUserRole from 'utils/user/useUserRole'
import { useCapturedWine } from '../_methods/context'

export const useRecognizeAdd = (capturedWineId: string) => {
  const { t } = useTranslation()
  const notify = useNotification()
  const { isAuthor, authorUserId, canEdit: canEditCtx } = useCapturedWine()
  const { isContent, isSuperAdmin } = useUserRole()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [save] = useProductRecognitionResultSaveMutation()

  const isAdmin = isContent || isSuperAdmin
  const canAdd = canEditCtx !== undefined ? canEditCtx : isAuthor || isAdmin

  const handleConfirm = async (
    productRecognition: RecognitionResultProduct
  ) => {
    const { errors } = await save({
      variables: {
        input: {
          rid: productRecognition.rid,
          ...(isAdmin && authorUserId ? { userId: authorUserId } : {}),
        },
      },
      refetchQueries: [
        {
          query: CapturedWineDocument,
          variables: { id: capturedWineId, localeId: getLocaleId() },
        },
      ],
    })
    if (errors) {
      notify(errors[0].message, 'error')
      return
    }
    notify(t('capturedWines.dialog.addWine.added'), 'success')
    setDialogOpen(false)
  }

  return { dialogOpen, setDialogOpen, handleConfirm, canAdd }
}
